module.exports = __webpack_public_path__ + "img/A4-3.99fdcd55.jpg";